'use strict';

Object.defineProperty(exports, '__esModule', {
    value: true
});

var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

var _angular = require('angular');

var _angular2 = _interopRequireDefault(_angular);

var YoutubeSDKService = (function () {

    /**
     *
     */

    function YoutubeSDKService() {
        var _this = this;

        _classCallCheck(this, YoutubeSDKService);

        this.done = true;
        this.el = null;
        this.player = null;

        window.onYouTubeIframeAPIReady = function () {
            _this._initPlayer(); //YT events init.
        };

        this.init();
    }

    /**
     *
     */

    _createClass(YoutubeSDKService, [{
        key: 'init',
        value: function init() {
            var tag = document.createElement('script'),
                firstScriptTag = document.getElementsByTagName('script')[0];

            tag.src = 'https://www.youtube.com/iframe_api';
            firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
        }

        /**
         *
         */
    }, {
        key: '_initPlayer',
        value: function _initPlayer() {
            this.player = new YT.Player(document.getElementById('player'), {
                width: 145,
                height: 70,

                events: {
                    onReady: this.onPlayerReady,
                    onStateChange: this.onPlayerStateChange
                },

                playerVars: {
                    enablejsapi: 1,
                    controls: 2,
                    showinfo: 0,
                    disablekb: 1,
                    fs: 0,
                    iv_load_policy: 3,
                    modestbranding: 1,
                    loop: 0,
                    playinline: 1,
                    theme: 'light',
                    rel: 0
                }
            });
        }

        /**
         *
         */
    }, {
        key: 'onPlayerReady',
        value: function onPlayerReady(event) {
            event.target.playVideo();
        }

        /**
         *
         */
    }, {
        key: 'onPlayerStateChange',
        value: function onPlayerStateChange(event) {}

        /**
         *
         */
    }, {
        key: 'stopVideo',
        value: function stopVideo() {
            this.player.stopVideo();
        }

        /**
         *
         */
    }, {
        key: 'load',
        value: function load(videoID) {
            this.player.loadVideoById({
                videoId: videoID,
                startSeconds: 0,
                suggestedQuality: 'large'
            });
        }
    }]);

    return YoutubeSDKService;
})();

exports['default'] = YoutubeSDKService;

YoutubeSDKService.$inject = [];
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./resources/assets/js/src/modules/youtube/service/youtube_sdk.js
 ** module id = 34
 ** module chunks = 0
 **/